module.exports = __webpack_public_path__ + "img/pc_banner_cooperation.e2e1c45a.jpg";